import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MainMenu from './mainmenu';
import SideBar from './SideBar';
import { useNavigate } from 'react-router-dom';
import CookieConsent from '../components/CookieConsent';
import Cookies from 'js-cookie';
import './HeaderOne.css';

export default function HeaderOne() {
    const navigate = useNavigate();
    const signedIn = Cookies.get('token') ? Cookies.get('token').length > 5 : false;

    const openSideBar = () => {
        document.body.classList.add('on-side');
    };

    const [isScrolled, setIsScrolled] = useState(false);
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;
            setIsScrolled(currentScrollY > 10);
            
            if (currentScrollY > lastScrollY && currentScrollY > 100) {
                setIsNavbarVisible(false);
            } else {
                setIsNavbarVisible(true);
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    return (
        <>
            <CookieConsent />
            <div className="body-overlay activemode"></div>
            <SideBar />
            <header className={`tl-header-wrapper ${isNavbarVisible ? 'visible' : 'hidden'} ${isScrolled ? 'scrolled' : ''}`}>
                <div className="tl-header-inner">
                    <div className="tl-header-container">
                        {/* Logo */}
                        <Link to="/" className="tl-logo-link">
                            <img src="assets/img/logo/logo2.png" alt="TextLink" className="tl-logo-icon" />
                            <span className="tl-logo-text">TextLink</span>
                        </Link>

                        {/* Center Menu */}
                        <div className="tl-menu-wrapper">
                            <MainMenu />
                        </div>

                        {/* Right Actions */}
                        <div className="tl-header-actions">
                            {!signedIn && (
                                <Link to="/signin" className="tl-signin-link">
                                    Sign in
                                </Link>
                            )}
                            <Link
                                to={signedIn ? '/dashboard' : '/signup'}
                                className="tl-cta-button"
                            >
                                {signedIn ? 'Dashboard' : 'Start sending free'}
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                </svg>
                            </Link>
                        </div>

                        {/* Mobile Menu Toggle */}
                        <button className="tl-mobile-menu-btn" onClick={openSideBar} aria-label="Open menu">
                            <span></span>
                            <span></span>
                            <span></span>
                        </button>
                    </div>
                </div>
            </header>
        </>
    );
}
